module.exports = __webpack_public_path__ + "media/9_10.e61bdfba.wav";